// click na inputy
window.$?.(document)?.ready?.(function()
{
// živé - např. editační režim, slide toggle podformulářku např Editovat, skrýt, smazat a zobrazit informace
    // toggle admin prvku v administraci
    $('.admin-subtitle').click(function() {
        $(this).next().slideToggle();
    });
    
    // po nacteni schovame vsechny admin panely -> pozdeji budeme ridit cookies?
    //$('.admin-part').hide();

// pravděpodobně nežije
// fulltext nenalezeno

    if (parent === self) { // nejsem v iframe !!
        if ($.isFunction($.fancybox)) {
            // inicializace fancyboxu na hash
            $(".fBoxHash").fancybox({
                type: 'inline',
            });
            // bohužel furt žije :)
            // inicializace fancyboxu ajax
            $(".fBox").fancybox({
                type: 'ajax',
            });
            // asi žije na veřejným webu, ale main není zrovna všude....
            // inicializace fancyboxu pro obrázky
            $(".fBoxImg, .fancybox").fancybox({
                type: 'image',
                openEffect: 'elastic',
                closeEffect: 'elastic',

                helpers: {
                    title: {
                        type: 'over'
                    }
                }
            });
        }
    } else if (parent.$?.isFunction?.(parent.$.fancybox)){ // iframe -- delegace fancybox na parenta //
        window.addEventListener('click', event=>{
            let target;
            if (target = event.target.closest('.fBoxHash, .fBox, .fBoxImg, .fancybox')) {
                let clone = target.cloneNode();
                parent.document.body.appendChild(clone);
                clone.click();
                clone.remove();
                event.preventDefault();
                return false
            }
        }, true);
    }

// až pocať

});

// žije -- předělat na confirm viz. confirm.js //
// kontrola pres confirm okno
window.$?.(document)?.delegate?.('input.checkBtn,button.checkBtn,a.check', "click", function(e)
{

    var msg = $(this).data('confirm');
    if (!msg)
    {
        msg = $(this).attr('title');
        if (!msg)
        {
            return true;
        }
        msg = "Potvrďte akci/Confirm action: \n" + msg;
    }
    ;

    if (!confirm(msg))
    {
        e.stopImmediatePropagation();
        return false;
    }
    return true;
});
